import { ChakraProvider, getTheme } from '@payflip/ui/v2';
import { ApolloClient } from '@payflip/web/apollo-client';
import { AuthProvider } from '@payflip/web/auth';
import { NuqsAdapter } from '@payflip/web/utils';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router';
import { App } from './components/app';
import { LocaleProvider } from './components/locale-provider';
import { ThemeProvider } from './components/theme-provider';
import { defaultThemeV2, queryClient } from './config';
import { authConfig, environment } from './environment';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);

const theme = getTheme(defaultThemeV2);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <NuqsAdapter>
      <BrowserRouter>
        <AuthProvider config={authConfig}>
          <ApolloClient uri={environment.GRAPHQL_API_URI}>
            <QueryClientProvider client={queryClient}>
              <HelmetProvider>
                <ThemeProvider>
                  <LocaleProvider>
                    <ChakraProvider theme={theme}>
                      <App />
                    </ChakraProvider>
                  </LocaleProvider>
                </ThemeProvider>
              </HelmetProvider>
            </QueryClientProvider>
          </ApolloClient>
        </AuthProvider>
      </BrowserRouter>
    </NuqsAdapter>
  </StrictMode>
);
